// src/store/slices/orderListSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

/**
 * 📌 Fetch Orders (with pagination + filters)
 */
export const fetchOrders = createAsyncThunk(
  "orderList/fetchOrders",
  async (_, thunkAPI) => {
    try {
      const { filters } = thunkAPI.getState().orderList; // ✅ Always pull from state
      const { data } = await axios.get(`/api/v1/orders/get-all-orders`, {
        params: filters // ✅ Sends page, limit, search, etc.
      });
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Failed to fetch orders"
      );
    }
  }
);

const orderListSlice = createSlice({
  name: "orderList",
  initialState: {
    orders: [],
    totalOrders: 0,
    totalPages: 0,
    loading: false,
    error: null,
    filters: {
      page: 1, // ✅ now inside filters
      limit: 10,
      search: "",
      email: "",
      status: "",
      payment_gateway: "",
      startDate: "",
      endDate: ""
    }
  },
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrders.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOrders.fulfilled, (state, action) => {
        state.loading = false;
        state.orders = action.payload.orders;
        state.totalOrders = action.payload.totalOrders;
        state.totalPages = action.payload.totalPages;
      })
      .addCase(fetchOrders.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      });
  }
});

export const { setFilters } = orderListSlice.actions;
export default orderListSlice.reducer;
